import splitExtension from '@modules/items/helpers/splitExtension.helper';

// A converted .dotx template shows a .docx display name but keeps .dotx bytes; name it by the blob.
const getStaticFileDownloadFilename = (displayName: string, blobName?: string): string => {
  const [base, nameExt] = splitExtension(displayName);
  const ext = splitExtension(blobName ?? '')[1] || nameExt;
  return ext ? `${base}.${ext}` : base;
};

export default getStaticFileDownloadFilename;
